var _token = "";
var _filterData = {
    page: 0,
    page_size: 20,
    industry_id: "",
    adcode: "",
    money: "",
    keyword: "",
    turn: "",
    create_at: ""
};
var _visited = {};

// var EXP={}
// EXP.init=function(){

// }

$.fn.datepicker.dates['zh-CN'] = {
    days: ["日", "一", "二", "三", "四", "五", "六"],
    daysShort: ["日", "一", "二", "三", "四", "五", "六"],
    daysMin: ["日", "一", "二", "三", "四", "五", "六"],
    months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    monthsShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    today: "Today",
    clear: "Clear",
    format: "mm/dd/yyyy",
    titleFormat: "MM yyyy",
    /* Leverages same syntax as 'format' */
    weekStart: 0
};

document.body.addEventListener('touchend', function(e) {
    if (e.target.tagName == "DIV") {
        $("#create-time-filter").datepicker('hide');
    }
}, false);

// $("#create-time-filter").datepicker({
//     format: "yyyy-mm-dd",
//     todayHighlight:true,
//     language:'zh-CN',
//     autoclose:true,
//     maxViewMode:2,
// }).on('changeDate',function(e){
//     $("#clear-time-filter").show();
//     if(!e.date){
//         return;
//     }
//     var date = new Date(e.date);
//     var year = date.getFullYear();
//     var month = date.getMonth() + 1;
//     if(month < 10){
//         month = '0' + month;
//     }
//     var day = date.getDate();
//     if(day < 10){
//         day = '0' + day;
//     }
//     console.log(year + '-' + month + '-' + day);
//     var filterDate = year + '-' + month + '-' + day;
//     $("#create-time-filter").html(filterDate);
//     _filterData.create_at = filterDate;
//     $("#create-time-filter").datepicker('hide');


//     //筛选文章
//     showLoadingGif();
//     _visited = {};
//     getFilterCondition();

//     getComInfoList(_token,_filterData,function(data){
//         //显示分页信息
//         var pagesConHTML = "";
//         var pages = getPages(data);
//         for(i=0;i<pages;i++){
//             pagesConHTML += '<div id="conetent-body-'+i+'"><div class="company-list"><ul class="items" id="company-title-field-'+ i +'"></ul></div><div class="detail-list"><ul class="items" id="company-detail-field-'+i+'"></ul></div><div class="clearfix"></div></div>';
//         }
//         $("#content-body").html(pagesConHTML);
//         showPagesInfo();
// //        showComInfoList(data,$("#companyList-0"));
//         showComInfoList(data,$("#company-title-field-0"),$("#company-detail-field-0"),0);
//         _visited["page-0"] = "visited";
//         if(data.data._pageinfo.total_count == 0){
//             $("#content-body").html('<div class="no_res_tip"><img src="/imgs/no_favorites.png"><p>没有筛选结果</p></div>');
//             $("#block-footer").hide();
//         }else{
//             $("#block-footer").show();
//         }

//     });

// }).on('show',function(){
//     $("#create-time-filter").addClass("dropdown-turndown");
// }).on('hide',function(){
//     $("#create-time-filter").removeClass("dropdown-turndown");
// });
moment.locale('zh-cn')
$('#create-time-filter').daterangepicker({
    locale: {
        format: 'YYYY-MM-DD',
        applyLabel: '确认',
        cancelLabel: '取消'
    },
}, function(start, end, label) {
    var _start = moment(start).format('YYYY-MM-DD');
    var _end = moment(end).format('YYYY-MM-DD');

    $("#create-time-filter").html(_start + '至' + _end);
    _filterData.start = _start;
    _filterData.end = _end;
    $("#create-time-filter").datepicker('hide');

    //筛选文章
    showLoadingGif();
    _visited = {};
    getFilterCondition();

    getComInfoList(_token, _filterData, function(data) {
        //显示分页信息
        var pagesConHTML = "";
        var pages = getPages(data);
        for (i = 0; i < pages; i++) {
            pagesConHTML += '<div id="conetent-body-' + i + '"><div class="company-list"><ul class="items" id="company-title-field-' + i + '"></ul></div><div class="detail-list"><ul class="items" id="company-detail-field-' + i + '"></ul></div><div class="clearfix"></div></div>';
        }
        $("#content-body").html(pagesConHTML);
        showPagesInfo();
        //        showComInfoList(data,$("#companyList-0"));
        showComInfoList(data, $("#company-title-field-0"), $("#company-detail-field-0"), 0);
        _visited["page-0"] = "visited";
        if (data.data._pageinfo.total_count == 0) {
            $("#content-body").html('<div class="no_res_tip"><img src="/imgs/no_favorites.png"><p>没有筛选结果</p></div>');
            $("#block-footer").hide();
        } else {
            $("#block-footer").show();
        }

    });
});

if ($.jStorage.get("localToken")) {
    _token = $.jStorage.get("localToken");
}
getIndustryList(_token, function(data) {
    showIndustryList(data);
});
getAddrList(_token, function(data) {
    showAddrList(data);
});

resetFilterCondition();
window.onresize = function() {
    throttle(function() {
        $("#industry_select,#son_industry_select,#province_select,#financial_select,#stage_select").select2({
            dropdownAutoWidth: true
        });
    });
}
$("#industry_select,#son_industry_select,#province_select,#financial_select,#stage_select").select2({
    dropdownAutoWidth: true
});
showLoadingGif();
getComInfoList(_token, _filterData, function(data) {
    //显示分页信息
    var pagesConHTML = "";
    var pages = getPages(data);
    for (i = 0; i < pages; i++) {
        pagesConHTML += '<div id="conetent-body-' + i + '"><div class="company-list"><ul class="items" id="company-title-field-' + i + '"></ul></div><div class="detail-list"><ul class="items" id="company-detail-field-' + i + '"></ul></div><div class="clearfix"></div></div>';
        // pagesConHTML += '<div id="conetent-body-' + i + '"></div>';
    }
    $("#content-body").html(pagesConHTML);
    showPagesInfo();
    //        showComInfoList(data,$("#companyList-0"));
    showComInfoList(data, $("#company-title-field-0"), $("#company-detail-field-0"), 0);
    _visited["page-0"] = "visited"

});

//点击去认证
$("#go_cert_btn").click(function() {
    if (IsPC()) {
        location.href = "/usercenter?cate=my-certification";
    } else {
        location.href = "/m_certification";
    }
});

$("#filter-submit,#clear-time-filter").click(function() {
    $("#create-time-filter").datepicker('clearDates');
    $("#clear-time-filter").hide();
    $("#create-time-filter").html("录入时间筛选");
    showLoadingGif();
    _visited = {};
    getFilterCondition();
    _filterData.create_at = "";
    getComInfoList(_token, _filterData, function(data) {
        //显示分页信息
        var pagesConHTML = "";
        var pages = getPages(data);
        for (i = 0; i < pages; i++) {
            pagesConHTML += '<div id="conetent-body-' + i + '"><div class="company-list"><ul class="items" id="company-title-field-' + i + '"></ul></div><div class="detail-list"><ul class="items" id="company-detail-field-' + i + '"></ul></div><div class="clearfix"></div></div>';
        }
        $("#content-body").html(pagesConHTML);
        showPagesInfo();
        //        showComInfoList(data,$("#companyList-0"));
        showComInfoList(data, $("#company-title-field-0"), $("#company-detail-field-0"), 0);
        _visited["page-0"] = "visited";
        if (data.data._pageinfo.total_count == 0) {
            $("#content-body").html('<div class="no_res_tip"><img src="/imgs/no_favorites.png"><p>没有筛选结果</p></div>');
            $("#block-footer").hide();
        } else {
            $("#block-footer").show();
        }

    });
});

$("#filter-reset").click(function() {
    showLoadingGif();
    $("#create-time-filter").datepicker('clearDates');
    $("#clear-time-filter").hide();
    $("#create-time-filter").html("录入时间筛选");
    _visited = {};
    getIndustryList(_token, function(data) {
        showIndustryList(data);
    });
    getAddrList(_token, function(data) {
        showAddrList(data);
    });
    resetFilterCondition();
    getComInfoList(_token, _filterData, function(data) {
        //显示分页信息
        closeLoadingGif();
        var pagesConHTML = "";
        var pages = getPages(data);
        for (i = 0; i < pages; i++) {
            pagesConHTML += '<div id="conetent-body-' + i + '"><div class="company-list"><ul class="items" id="company-title-field-' + i + '"></ul></div><div class="detail-list"><ul class="items" id="company-detail-field-' + i + '"></ul></div><div class="clearfix"></div></div>';
        }
        $("#content-body").html(pagesConHTML);
        showPagesInfo();
        //        showComInfoList(data,$("#companyList-0"));
        showComInfoList(data, $("#company-title-field-0"), $("#company-detail-field-0"), 0);
        _visited["page-0"] = "visited";
        if (data.data._pageinfo.total_count == 0) {
            $("#content-body").html('<div class="no_res_tip"><img src="/imgs/no_favorites.png"><p>没有筛选结果</p></div>');
            $("#block-footer").hide();
        } else {
            $("#block-footer").show();
        }

    });
});





//点击提示字的时候，也使输入框获得焦点
//$("#search-tips").click(function(){
//    $("#filter_keyword").focus();
//});


//监听搜索关键词的输入框，使提示字消失
$("#filter_keyword").bind('change onpropertychange input', function() {
    if ($("#filter_keyword").val() != "") {
        $("#search-tips").hide();
    } else {
        $("#search-tips").show();
    }
});

$("#filter_keyword").on('keyup', function(e) {
    if (e.keyCode == '13') {
        $("#filter-submit").click();
    }
})

$("#export_btn").click(function() {
    showLoadingGif();
    var checked = $("input.items-company-checkbox:checked");
    var arr = [];

    for (i = 0; i < checked.length; i++) {
        //        console.log($(checked[i]).val());
        arr.push($(checked[i]).val());
    }
    if (arr.length == 0) {
        showWarning("您没有选择数据，没有数据可以导出");
        closeLoadingGif();
        return;
    } else if (arr.length > 50) {
        showWarning("最多只能导出50条数据哦~");
        closeLoadingGif();
        return;
    }

    if (IsPC()) {
        console.log(arr);
        exportCompanyList(_token, arr, "", function(data) {
            showExportDownload(data);
        })
    } else {
        showEmailInputBox();
        closeLoadingGif();


    }
});

$("#email-export-btn").click(function() {
    var checked = $("input.items-company-checkbox:checked");
    var arr = [];

    for (i = 0; i < checked.length; i++) {
        //        console.log($(checked[i]).val());
        arr.push($(checked[i]).val());
    }
    if (arr.length == 0) {
        showWarning("您没有选择数据，没有数据可以导出");
        closeLoadingGif();
        return;
    } else if (arr.length > 50) {
        showWarning("最多只能导出50条数据哦~");
        closeLoadingGif();
        return;
    }
    var email = $("#email-input").val();
    showLoadingGif();
    $("#email-export-btn").attr("disabled", true);
    console.log(arr);
    exportCompanyList(_token, arr, email, function() {
        $("#email_pane").modal('hide');
        $('#email_pane').on('hidden.bs.modal', function() {
            $("#email-export-btn").removeAttr("disabled");
        })

    });
});

function showEmailInputBox() {
    $("#email_pane").modal('show');
    var email = "";
    if ($.jStorage.get("localEmail")) {
        email = $.jStorage.get("localEmail");
    }
    $("#email-input").val(email);
}

function getPages(data) {
    return data.data._pageinfo.pages;
}

function showExportDownload(data) {
    var downloadUrl = data.data.data.url;
    $("#download_addr").attr("href", v1url + downloadUrl);
    $("#download_pane").modal('show');
}

//显示底部分页
function showPagesInfo() {
    if (IsPC()) {
        $("#export_pages").jPages({
            containerID: "content-body",
            perPage: 1,
            first: "首页",
            last: "尾页",
            callback: function(pages, items) {
                var page = pages.current - 1;
                _filterData.page = page;
                if (_visited["page-" + page]) {
                    closeLoadingGif();
                    return;
                }
                if (page == 0) {
                    $(".detail-list").css('min-height', document.getElementById("content-body").offsetHeight);
                    return;
                } else {
                    showLoadingGif();
                }
                getComInfoList(_token, _filterData, function(data) {
                    _visited["page-" + page] = "visited"
                        //                $("#conetent-body-" + page).empty();
                    showComInfoList(data, $("#company-title-field-" + page), $("#company-detail-field-" + page), page);
                    $(".detail-list").css('min-height', document.getElementById("content-body").offsetHeight);
                });

            }
        });
    } else {
        $("#export_pages").jPages({
            containerID: "content-body",
            perPage: 1,
            midRange: "1",
            callback: function(pages, items) {
                var page = pages.current - 1;
                showLoadingGif();
                _filterData.page = page;
                if (_visited["page-" + page]) {
                    closeLoadingGif();
                    return;
                }
                if (page == 0) {
                    closeLoadingGif();
                    return;
                }
                getComInfoList(_token, _filterData, function(data) {
                    _visited["page-" + page] = "visited"
                        //                $("#conetent-body-" + page).empty();
                    showComInfoList(data, $("#company-title-field-" + page), $("#company-detail-field-" + page), page);
                    $(".detail-list").css('min-height', document.getElementById("content-body").offsetHeight);
                });
            }
        });
    }

}


//获得筛选后的参数
function getFilterCondition() {

    //获取行业ID
    var industry_id = "";
    var f_industry_id = $("#industry_select").children("option:selected").attr("industry_id");
    var s_industry_id = $("#son_industry_select").children("option:selected").attr("industry_id");
    if (s_industry_id) {
        industry_id = s_industry_id;
    } else if (f_industry_id) {
        industry_id = f_industry_id;
    }
    //    console.log("industry_id::" + industry_id);

    //获取地址ID
    var adcode = "";
    var proCode = $("#province_select").children("option:selected").attr("adcode");
    var cityCode = $("#city_select").children("option:selected").attr("adcode");
    var distCode = $("#dist_select").children("option:selected").attr("adcode");
    var keyword = $("#filter_keyword").val();
    if (distCode) {
        adcode = distCode;
    } else if (cityCode) {
        adcode = cityCode;
    } else if (proCode) {
        adcode = proCode;
    }
    //    console.log("adcode::" + adcode);

    //获取融资金额代码
    var money = "";
    var moneyCode = $("#financial_select").children("option:selected").attr("count");
    if (moneyCode) {
        money = moneyCode;
    }

    //获取融资信息
    var stage = "";
    var stageTemp = $("#stage_select").children("option:selected").attr("stage");
    if (stageTemp) {
        stage = stageTemp;
    }
    //    console.log("money::" + money);
    _filterData.industry_id = industry_id;
    _filterData.adcode = adcode;
    _filterData.money = money;
    _filterData.keyword = keyword;
    _filterData.turn = stage;

}

function resetFilterCondition() {
    _filterData.industry_id = "";
    _filterData.adcode = "";
    _filterData.money = "";
    _filterData.keyword = "";
    _filterData.turn = "";
    _filterData.create_at = "";
    $("#financial_select").val("default-count").trigger("change");
    $("#stage_select").val("default-stage").trigger("change");
}

//获得行业列表
function getIndustryList(token, fun) {
    $.get({
        url: v1url + "company/allindustry",
        headers: {
            devicetoken: cookie_PENCILNEWSID,
            token: token,
        },
        success: function(data) {
            if (data.code == 1000) {
                fun(data);
            } else if (data.code == -1) {
                showLoginPage();
            }
        },
        error: function() {}
    })
}

//显示所有行业
function showIndustryList(data) {
    var industries = data.data.list;
    var industryHTML = "<option index='none'>行业</option>";

    for (i = 0; i < industries.length; i++) {
        var industryList = industries[i];
        var industryId = industryList.industry_id;
        var industryName = industryList.name;
        industryHTML += '<option class="f_industry_list" industry_id="' + industryId + '" index="' + i + '">' + industryName + '</option>';
    }
    $("#industry_select").html(industryHTML);
    $("#son_industry_select").html("<option index='none'>子行业</option>");
    $("#industry_select").change(function() {
        var sonIndustryHTML = "<option>子行业</option>";
        var _this = $(this);
        var index = _this.children('option:selected').attr("index")
        if (index != "none") {
            var sonIndustries = industries[index].sons;
            for (i = 0; i < sonIndustries.length; i++) {
                var sonList = sonIndustries[i];
                var sonId = sonList.industry_id;
                var sonName = sonList.name;
                sonIndustryHTML += '<option class="s_industry_list" industry_id="' + sonId + '" index="' + i + '">' + sonName + '</option>';
            }
        }
        $("#son_industry_select").html(sonIndustryHTML);
    });
}

//获得地址信息列表
function getAddrList(token, fun) {
    $.get({
        url: v1url + "company/alladdr",
        headers: {
            devicetoken: cookie_PENCILNEWSID,
            token: token
        },
        success: function(data) {
            if (data.code == 1000) {
                fun(data);
            } else {
                showLoginPage();
            }
        },
        error: function() {}
    });
}

//显示地址信息列表
function showAddrList(data) {
    var addrList = data.data.list;
    var provinceHTML = "<option index='none'>地区</option>";
    var cityList = "";

    for (i = 0; i < addrList.length; i++) {
        var province = addrList[i];
        var proAdcode = province.adcode;
        var proName = province.name;
        provinceHTML += '<option adcode="' + proAdcode + '" index="' + i + '">' + proName + '</option>'
    }
    $("#province_select").html(provinceHTML);
    $("#city_select").html("<option index='none'>市/辖区</option>");
    $("#dist_select").html("<option index='none'>区/县</option>");

    $("#province_select").change(function() {
        var cityHTML = "<option index='none'>市/辖区</option>";
        var _this = $(this);
        var index = _this.children("option:selected").attr("index");
        if (index != "none") {
            cityList = addrList[index].sons;
            for (i = 0; i < cityList.length; i++) {
                var city = cityList[i];
                var cityAdcode = city.adcode;
                var cityName = city.name;
                cityHTML += '<option adcode="' + cityAdcode + '" index="' + i + '">' + cityName + '</option>'
            }
        }

        $("#city_select").html(cityHTML);
        $("#dist_select").html("<option index='none'>区/县</option>");
    });

    $("#city_select").change(function() {
        var distHTML = "<option index='none'>区/县</option>"
        var _this = $(this);
        var index = _this.children("option:selected").attr("index");
        if (index != "none") {
            var distList = cityList[index].sons;
            for (i = 0; i < distList.length; i++) {
                var dist = distList[i];
                var distAdcode = dist.adcode;
                var distName = dist.name;
                distHTML += '<option adcode="' + distAdcode + '" index="' + i + '">' + distName + '</option>'
            }
        }

        $("#dist_select").html(distHTML);
    });



}

//获得公司信息列表
function getComInfoList(token, filterData, fun) {
    $.get({
        url: v1url + "company/contents",
        headers: {
            devicetoken: cookie_PENCILNEWSID,
            token: token,
        },
        data: filterData,
        success: function(data) {
            closeLoadingGif();
            if (data.code == 1000) {
                fun(data);
            } else if (data.code == -1) {
                showWarning("登录已过期，请重新登录");
                showLoginPage();
            } else {
                $("#gocert_pane").modal("show");
                //                showWarning(data.message);
                //                setTimeout(function(){
                //                    location.href = "/usercenter?cate=my-certification";
                //                },3000);
            }

        },
        error: function() {}
    });
}

function showComInfoList(data, titleObj, detailObj, pageNumber) {
    var pageInfo = data.data._pageinfo;
    var contents = data.data.contents;
    var totalNumber = pageInfo.total_count;
    var contentHTML = "";
    var comListTitleHTML = '<li><div><label><input type="checkbox" class="check-all-page-' + pageNumber + '"><span class="company-list-name">公司名称</span></label></div></li>';
    var comListHTML = '';
    comListHTML += comListTitleHTML;
    // var comDetailTitleHTML = '<li><div>收录时间</div><div>创始人</div><div>行业</div><div>投资方</div><div>所处城市</div><div>融资金额</div><div>融资轮次</div><div>币种</div><div>办公地址</div><div>创始人背景</div><div>业务</div><div>盈利模式</div><div>运营数据</div><div>未来规划</div></li>';
    var comDetailTitleHTML = '<li><div>收录时间</div><div>创始人</div><div>行业</div><div>投资方</div><div>融资金额</div><div>融资轮次</div><div>更多</div></li>';
    var comDetailHTML = '';
    comDetailHTML += comDetailTitleHTML;
    for (i = 0; i < contents.length; i++) {
        var content = contents[i];

        var createAt = content.create_at;
        var isDownLoad = content.is_download;
        var formToken = content.form_token;
        var isDownLoadClass = "";
        if (isDownLoad == 1) {
            isDownLoadClass = " item-downloaded-font";
        }


        var collectTime = createAt.split('-')[0] + '-' + createAt.split('-')[1];
        //公司
        var company = content["655"] || "-";
        //创始人
        var creator = content["656"] || "-";
        //投资方
        var investor = content["658"] || "-";
        //融资金额
        var financial = content["659"] || "-";
        //融资阶段
        var stage = content["660"] || "-";
        //币种
        var currency = content["661"] || "-";
        //所属行业
        var industry = content["662"] || "-";
        //办公地址
        var address = content["663"] || "-";
        //城市
        var city = content["664"] || "-";
        //创始人背景
        var creatorBackground = content["665"] || "-";
        //背景
        var background = content["666"] || "-";
        //盈利模式
        var profitModel = content["667"] || "-";
        //运营数据
        var operationData = content["668"] || "-";
        //未来规划
        var plan = content["669"] || "-";

        var article_id = content["article_id"]

        if (article_id) {
            comListHTML +=
                '<li class="company-' + pageNumber + '-' + i + isDownLoadClass + '">' +
                '<div>' +
                '<input type="checkbox" company-id="company-' + pageNumber + '-' + i + '" class="items-company-checkbox items-page-' + pageNumber + '" value="' + formToken + '" class="check-one-item">' +
                '<a href="/p/' + article_id + '.html" target="_blank" style="color:#337ab7;">' +
                '<span class="company-list-logo" style="background-image:url(' + content.logo + ') no-repeat;background-size:100%;"></span>' +
                '<span class="company-list-name">' + company + '</span>' +
                '</a>' +
                '</div>' +
                '</li>';
        } else {
            comListHTML +=
                '<li class="company-' + pageNumber + '-' + i + isDownLoadClass + '">' +
                '<div>' +
                '<label>' +
                '<input type="checkbox" company-id="company-' + pageNumber + '-' + i + '" class="items-company-checkbox items-page-' + pageNumber + '" value="' + formToken + '" class="check-one-item">' +
                '<span class="company-list-logo" style="background-image:url(' + content.logo + ') no-repeat;background-size:100%;"></span>' +
                '<span class="company-list-name">' + company + '</span>' +
                '</label>' +
                '</div>' +
                '</li>';
        }

        //        comDetailHTML += '<li class="company-'+pageNumber+'-'+i+' company-hover-mark"><div><div class="detail-text">'+ creator +'</div><div class="full-detail-text"></div></div><div>'+ industry +'</div><div>'+ investor +'</div><div>'+ city +'</div><div>'+ financial +'</div><div>'+ stage +'</div><div>'+ currency +'</div><div>'+ industry +'</div><div>'+ creatorBackground +'</div><div>'+ profitModel +'</div><div>'+ operationData +'</div><div>'+ plan +'</div></li>';

        comDetailHTML +=
            '<li class="company-' + pageNumber + '-' + i + isDownLoadClass + ' company-hover-mark">' +
            '<div>' +
            '<div class="detail-text">' + collectTime + '</div>' +
            '<div class="full-detail-text">' + createAt + '</div>' +
            '</div>' +
            '<div>' +
            '<div class="detail-text">' + creator + '</div>' +
            '<div class="full-detail-text">' + creator + '</div>' +
            '</div>' +
            '<div>' +
            '<div class="detail-text">' + industry + '</div>' +
            '<div class="full-detail-text">' + industry + '</div>' +
            '</div>' +
            '<div>' +
            '<div class="detail-text">' + investor + '</div>' +
            '<div class="full-detail-text">' + investor + '</div>' +
            '</div>' +
            // '<div>' +
            // '<div class="detail-text">' + city + '</div>' +
            // '<div class="full-detail-text">' + city + '</div>' +
            // '</div>' +
            '<div>' +
            '<div class="detail-text">' + financial + '</div>' +
            '<div class="full-detail-text">' + financial + '</div>' +
            '</div>' +
            '<div>' +
            '<div class="detail-text">' + stage + '</div>' +
            '<div class="full-detail-text">' + stage + '</div>' +
            '</div>' +
            '<div>' +
            '<a class="more" target="_blank" href="/export/'+formToken+'">...</a>' +
            '</div>';


        // '<div><div class="detail-text">' + currency + '</div><div class="full-detail-text">' + currency + '</div></div><div><div class="detail-text">' + address + '</div><div class="full-detail-text">' + address + '</div></div><div><div class="detail-text">' + creatorBackground + '</div><div class="full-detail-text">' + creatorBackground + '</div></div><div><div class="detail-text">' + background + '</div><div class="full-detail-text">' + background + '</div></div><div><div class="detail-text">' + profitModel + '</div><div class="full-detail-text">' + profitModel + '</div></div><div><div class="detail-text">' + operationData + '</div><div class="full-detail-text">' + operationData + '</div></div><div><div class="detail-text">' + plan + '</div><div class="full-detail-text">' + plan + '</div></div></li>';

        //        contentHTML += '<div class="panel panel-info"><div class="panel-heading"><h4 class="panel-title"><span><input class="item_check" type="checkbox" value="'+ formToken +'"></span><a data-toggle="collapse" data-parent="#accordion" href="#'+ formToken +'">'+ company +'</a></h4></div><div class="panel-collapse collapse" id="'+ formToken +'"><div class="panel-body"><p>创始人：'+ creator +'</p><p>投资方：'+ investor +'</p><p>投资金额：'+ financial +'</p><p>融资阶段：'+ stage +'</p><p>币种：'+ currency +'</p><p>所属行业：'+ industry +'</p><p>办公地址：'+ address +'</p><p>城市：'+ city +'</p><p>创始人背景：'+ creatorBackground +'</p><p>背景：'+ background +'</p><p>盈利模式：'+ profitModel +'</p><p>运营数据：'+ operationData +'</p><p>未来规划：'+ plan +'</p></div></div></div>';

    }

    //    containerObj.append(contentHTML);
    console.log(detailObj)
    $("#content-sum-number").html(totalNumber);
    titleObj.html(comListHTML);
    detailObj.html(comDetailHTML);
    // var scrolldom = $("<div class='scroll-bar'><span></span></div>")
    // detailObj.parent().append(scrolldom)

    $('input.items-page-' + pageNumber + ',' + 'input.check-all-page-' + pageNumber).iCheck({
        checkboxClass: 'icheckbox_flat-orange',
        radioClass: 'iradio_flat-orange'
    });

    $('input.check-all-page-' + pageNumber).on('ifChecked', function(event) {
        $('input.items-page-' + pageNumber).iCheck('check');
        //        console.log($('input.items-page-'+pageNumber));
    });

    $('input.check-all-page-' + pageNumber).on('ifUnchecked', function(event) {
        $('input.items-page-' + pageNumber).iCheck('uncheck');
        //        console.log($('input.items-page-'+pageNumber));
    });

    $('input.items-company-checkbox').on('ifChecked', function() {
        var _this = $(this);
        var detailId = _this.attr("company-id");
        _this.addClass("item-checked-bg");
        $('.' + detailId).addClass("item-checked-bg");
    });

    $('input.items-company-checkbox').on('ifUnchecked', function() {
        var _this = $(this);
        var detailId = _this.attr("company-id");
        _this.removeClass("item-checked-bg");
        $('.' + detailId).removeClass("item-checked-bg");
    });



    $(".company-hover-mark>div").mousemove(function() {
        var _this = $(this);

        var bottomBorder = $(".block-content")[0].offsetTop + $(".block-content").height();


        var itemTop = _this[0].offsetTop;


        var fullTips = _this.children(".full-detail-text");
        if ((bottomBorder - itemTop) < 200) {
            fullTips.css({
                top: "auto",
                bottom: "35px"
            });
        }
        fullTips.show();
        fullTips.mousemove(function() {
            $(this).show();
        });
        fullTips.mouseout(function() {
            $(this).hide();
        });
    });


    $(".company-hover-mark>div").mouseout(function() {
        var _this = $(this);
        var fullTips = _this.children(".full-detail-text");
        fullTips.hide();
    });

    //滑动
    // (function() {
    //     var oldx, oldscrollx, scrollwidth, ismousedown = true;
    //     // detailObj.on('mousedown',function(e){
    //     //     if(1 != e.which){
    //     //         ismousedown = true
    //     //     }
    //     // })
    //     // Window.on('mouseup',function(e){
    //     //     ismousedown = true
    //     // })
    //     detailObj.on("mouseover", function(e) {
    //         if (ismousedown) {
    //             oldx = e.clientX;
    //             oldscrollx = detailObj.parent().scrollLeft();
    //         }
    //     })
    //     detailObj.on("mousemove", function(e) {
    //         if (ismousedown) {
    //             var newx = (e.clientX - oldx) * 5 + oldscrollx;
    //             detailObj.parent().scrollLeft(newx)
    //         }
    //     })

    //     // scrolldom.on("mousedown",function(e){
    //     //     if(1 == e.which){
    //     //         oldx = e.clientX;
    //     //         oldscrollx = detailObj.parent().scrollLeft();
    //     //         scrollwidth = $('.scroll-bar').width()
    //     //     }
    //     // })
    //     // scrolldom.on("mousemove",function(e){
    //     //     if(1 == e.which){
    //     //         var newx = (e.clientX - oldx)+oldscrollx;
    //     //         if(newx<=0 || newx >=1100)return;
    //     //         detailObj.parent().scrollLeft(newx)
    //     //         scrolldom.find('span').css({left:(newx/scrollwidth)*1100})
    //     //     }
    //     // })

    //     // $('#content-body').on('scroll',function(e){
    //     //     $('.scroll-bar').css({
    //     //         top:480+e.target.scrollTop
    //     //     })
    //     // })
    //     // $('#content-body').perfectScrollbar();
    // })()

    //    console.log($('input.check-all-page-'+pageNumber));


}

function exportCompanyList(token, form_token, email, fun) {
    //    console.log(form_token)
    $.get({
        url: v1url + "company/export",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID,
        },
        data: {
            "form_token": form_token,
            "email": email
        },
        success: function(data) {
            closeLoadingGif();
            //            console.log(data);
            if (data.code == -1) {
                showLoginPage();
                return;
            }
            if (data.code == 1000) {
                //                console.log(data.data.data.type)
                if (data.data.data.type == "email") {
                    showSuccess("导出成功，已经发送至邮箱");
                    fun();
                } else if (data.data.data.type == "url") {
                    fun(data);
                }
            } else if (data.code == -3) {
                showWarning("导出失败");
            } else if (data.code == 1004) {
                showWarning("最多导出50条数据");
            } else {
                showWarning(data.message);
            }
        },
        error: function() {

        }
    });
}
